import React from "react";
import { ArrowRight, CalendarClock, Instagram, Menu } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Sheet,
  SheetClose,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";

const NAV_ITEMS = [
  { href: "/", label: "Ana Sayfa", testId: "mobile-menu-home-link" },
  { href: "/isletmeler", label: "İşletmeler", testId: "mobile-menu-businesses-link" },
  { href: "/#ozellikler", label: "Özellikler", testId: "mobile-menu-features-link" },
  {
    href: "/#entegrasyonlar",
    label: "Entegrasyonlar",
    testId: "mobile-menu-integrations-link",
  },
  { href: "/#nasil", label: "Nasıl Çalışır", testId: "mobile-menu-how-link" },
  { href: "/#kimler", label: "Kimler İçin", testId: "mobile-menu-audience-link" },
  { href: "/#planlar", label: "Planlar", testId: "mobile-menu-plans-link" },
  { href: "/#sss", label: "SSS", testId: "mobile-menu-faq-link" },
];

export default function PublicMobileMenu() {
  return (
    <Sheet>
      <SheetTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="md:hidden"
          aria-label="Menüyü aç"
          data-testid="mobile-menu-trigger"
        >
          <Menu className="h-5 w-5" />
        </Button>
      </SheetTrigger>
      <SheetContent
        side="left"
        className="flex w-[300px] flex-col p-0 sm:max-w-[300px]"
        data-testid="mobile-menu-panel"
      >
        <SheetHeader className="border-b border-border p-6 text-left">
          <div className="flex items-center gap-2">
            <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary">
              <CalendarClock className="h-5 w-5 text-primary-foreground" />
            </div>
            <div>
              <SheetTitle className="font-display text-xl font-bold">365Rez</SheetTitle>
              <SheetDescription className="mt-0 text-xs">
                Online rezervasyon
              </SheetDescription>
            </div>
          </div>
        </SheetHeader>

        <nav className="space-y-1 p-4" aria-label="Mobil navigasyon">
          {NAV_ITEMS.map((item) => (
            <SheetClose key={item.href} asChild>
              <a
                href={item.href}
                className={
                  "flex items-center justify-between rounded-lg px-4 py-3 text-sm font-semibold "
                  + "text-foreground transition-colors hover:bg-accent"
                }
                data-testid={item.testId}
              >
                {item.label}
                <ArrowRight className="h-4 w-4 text-muted-foreground" />
              </a>
            </SheetClose>
          ))}
        </nav>

        <div className="mt-auto border-t border-border p-5">
          <SheetClose asChild>
            <a
              href="/giris"
              className={
                "flex h-11 items-center justify-center rounded-full bg-primary px-4 text-sm "
                + "font-semibold text-primary-foreground transition-colors hover:bg-primary/90"
              }
              data-testid="mobile-menu-login-link"
            >
              İşletme Girişi
            </a>
          </SheetClose>
          <a
            href="https://www.instagram.com/365rezervasyon/"
            target="_blank"
            rel="noreferrer"
            className={
              "mt-3 flex items-center justify-center gap-2 rounded-full border border-border px-4 "
              + "py-2.5 text-sm font-semibold transition-colors hover:bg-accent"
            }
            data-testid="mobile-menu-instagram-link"
          >
            <Instagram className="h-4 w-4" />
            Instagram
          </a>
        </div>
      </SheetContent>
    </Sheet>
  );
}